import { UserGroup } from './user-group';

export class PublisherUser {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    cellPhone: string;
    publisherId: string;
    password: string;
    userGroupId: string;
    userGroup: UserGroup;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/publisher-user.ts